import React, { useEffect } from 'react'
import { useAppContext } from './AppContext'
import { FixMeLater } from '../types'
import { Footer } from './Footer'

export type PageProps = {
	children: React.ReactNode
	page?: string
	title?: string
	isFullWidth?: boolean
	noDarkMode?: boolean
	showFooter?: boolean
}

const getPageTitle = (name: string, title?: string) => {
	if (title && name) {
		return `${name} - ${title}`
	}

	if (title) {
		return title
	}

	return name
}

export default function Page({
	children,
	page = '',
	title,
	isFullWidth = false,
	noDarkMode = false,
	showFooter = false,
}: Readonly<PageProps>) {
	const { state } = useAppContext()
	const { siteConfig, legalLinks, socialLinks } = state

	useEffect(() => {
		const titleName = (siteConfig as FixMeLater)?.name ?? ''

		document.title = getPageTitle(titleName, title)
	}, [title, siteConfig])

	return (
		<div className={`${noDarkMode ? '' : 'dark:bg-[#121212]'}`}>
			<div
				className={`${page} ${isFullWidth ? '' : 'max-w-screen-xl'} mx-auto ${noDarkMode ? '' : 'dark:bg-[#121212]'}`}
			>
				{children}
			</div>
			{showFooter && (
				<Footer
					siteConfig={siteConfig as FixMeLater}
					socialLinks={socialLinks}
					legalLinks={legalLinks}
				/>
			)}
		</div>
	)
}
